import { type ShippingAgencyTransferPayload } from "@services/shipping-agency-transfer/types";
import type { RequestShippingAgencyTransferFormData } from "./../schema/requestShippingAgencyTransferSchema";

const mapRequestShippingAgencyTransferFormToPayload = (
  vesselCallId: string,
  formData: RequestShippingAgencyTransferFormData,
): ShippingAgencyTransferPayload => {
  const transferDate = formData["transfer-date-and-time"];

  return {
    vesselCallId: vesselCallId,
    newShippingAgency: {
      companyCode: formData["new-shipping-agency"],
    },
    transferDateAndTime:
      transferDate instanceof Date ? transferDate.toISOString() : transferDate || "",
    additionalDocuments: formData["additional-documents"]!.map((doc) => ({
      originalFileName: doc.name,
      url: doc.url,
      fileformat: doc.type,
      type: doc.documentType,
      specify: doc.otherSpecifyType,
      name: doc.documentName,
      issueDate:
        doc.issueDate instanceof Date ? doc.issueDate.toISOString() : (doc.issueDate ?? null),
      expiryDate:
        doc.expiryDate instanceof Date ? doc.expiryDate.toISOString() : (doc.expiryDate ?? null),
      summary: doc.documentSummary,
    })),
  };
};
export default mapRequestShippingAgencyTransferFormToPayload;
